import KpRecordExports from './KpRecordExports.svelte';

export default class RecordExportsController {
    public recordExportComponent = KpRecordExports;
}
